// ==============================================================================================

import fetchHandler from '../../api/Handler';

export const AuthenticationAPI = {
	tokenRefreshInterval: null as NodeJS.Timeout | null,
	async Login(data: any): Promise<{ isError: boolean; error?: any; data?: any } | null> {
		try {
			const response = await fetchHandler({
				method: 'POST',
				endpoint: 'vendors/verify-otp',
				data,
			});
			if (response.isError) {
				return { isError: true, error: response.data };
			}

			// localStorage.setItem(TOKEN_STORAGE_KEY, response.data.refreshToken);
			// sessionStorage.setItem('username', response.adminname);
			// sessionStorage.setItem('email', response.email);

			// this.startTokenRefreshInterval();

			return { isError: false, data: response };
		} catch (error) {
			console.error('Login error:', error);
			return { isError: true, error: 'An unexpected error occurred.' };
		}
	},
	async SendOtp(
		data: any
		// tokenId: string
	): Promise<{ isError: boolean; error?: any; data?: any } | null> {
		try {
			const response = await fetchHandler({
				method: 'POST',
				endpoint: `vendors/send-otp`,
				data,
			});
			if (response.isError) {
				return { isError: true, error: response.data };
			} else {
			}

			return { isError: false, data: response };
		} catch (error) {
			console.error('Reset password error:', error);
			return { isError: true, error: 'An unexpected error occurred.' };
		}
	},
	async ResendOtp(
		data: any
		// tokenId: string
	): Promise<{ isError: boolean; error?: any; data?: any } | null> {
		try {
			const response = await fetchHandler({
				method: 'POST',
				endpoint: `vendors/send-otp`,
				data,
			});
			if (response.isError) {
				return { isError: true, error: response.data };
			}

			return { isError: false, data: response };
		} catch (error) {
			console.error('Reset password error:', error);
			return { isError: true, error: 'An unexpected error occurred.' };
		}
	},
};
